// 指定した　　window　の PostMessage を待つための関数

export type WaitForPostMessageOptions = {
  // 送信元 window
  sourceWindow: Window;
  // data.type を絞りたい場合（未指定なら type は未検証）
  expectedType: string | null;
  // 送信元　origin、未指定なら window.location.origin を使う。null を渡すと無検証
  expectedOrigin: string | null;
};

export function waitForPostMessage<T>({
  expectedType,
  expectedOrigin = window.location.origin,
  sourceWindow,
}: WaitForPostMessageOptions): Promise<T> {
  if (typeof window === 'undefined') {
    throw new Error('waitForPostMessage must be called in the browser');
  }

  return new Promise<T>((resolve) => {
    const handler = (ev: MessageEvent) => {
      if (expectedOrigin !== null && ev.origin !== expectedOrigin) return;
      if (sourceWindow && ev.source !== sourceWindow) return;

      const data = ev.data;
      if (expectedType && (!data || data.type !== expectedType)) return;

      resolve(data);
      window.removeEventListener('message', handler);
    };

    window.addEventListener('message', handler);
  });
}
